import { createAction, createRequestConst } from '../util';

export const CREATE_GUEST_PAYER_AND_JWT = createRequestConst(
  'CREATE_GUEST_PAYER_AND_JWT'
);

export const createGuestPayerAndJwt = createAction(CREATE_GUEST_PAYER_AND_JWT);

export const OPEN_PAYMENT_IFRAME = 'OPEN_PAYMENT_IFRAME';
export const openPaymentIframe = (jwt, fspId, assertionBaseUrl) => ({
  type: OPEN_PAYMENT_IFRAME,
  data: {
    jwt,
    fspId,
    assertionBaseUrl,
  },
});

export const CLOSE_PAYMENT_IFRAME = 'CLOSE_PAYMENT_IFRAME';
export const closePaymentIframe = () => ({
  type: CLOSE_PAYMENT_IFRAME,
});

const initialState = {
  loading: false,
  error: null,
  data: {
    guestPayerInfo: null,
    jwt: null,
    jti: null,
    exp: null,
    assertionBaseUrl: null,
  },
  paymentIframe: {
    isOpen: false,
    jwt: null,
    fspId: null,
    assertionBaseUrl: null,
  },
};

export const selector = (state) => state.ifpPalPayment;

export default (state = initialState, { type, data = {}, error }) => {
  switch (type) {
    case CREATE_GUEST_PAYER_AND_JWT.ACTION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_GUEST_PAYER_AND_JWT.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          guestPayerInfo: data.guestPayerInfo || null,
          jwt: data.jwt || null,
          jti: data.jti || null,
          exp: data.exp || null,
          assertionBaseUrl: data.assertionBaseUrl || null,
        },
      };

    case CREATE_GUEST_PAYER_AND_JWT.FAILURE:
      return {
        ...state,
        loading: false,
        error:
          error?.data?.message ||
          error?.message ||
          'Failed to create guest payer and generate JWT',
        data: {
          guestPayerInfo: null,
          jwt: null,
          jti: null,
          exp: null,
          assertionBaseUrl: null,
        },
      };

    case OPEN_PAYMENT_IFRAME:
      return {
        ...state,
        paymentIframe: {
          isOpen: true,
          jwt: data.jwt,
          fspId: data.fspId,
          assertionBaseUrl: data.assertionBaseUrl,
        },
      };

    case CLOSE_PAYMENT_IFRAME:
      return {
        ...state,
        paymentIframe: {
          isOpen: false,
          jwt: null,
          fspId: null,
          assertionBaseUrl: null,
        },
      };

    default:
      return state;
  }
};
